import * as React from 'react';

import { observer } from 'mobx-react';

import { ITranslationsCollection } from '@estee/elc-service';

import { IRampPreloadedConfig } from '~domain/entities/Config';

type VulcanContextProps = {
    translations: ITranslationsCollection;
    config: IRampPreloadedConfig;
    children?: React.ReactNode;
};

const defaultContext = {
    config: {},
    translations: {}
};

export const VulcanContextProvider = React.createContext<VulcanContextProps>(defaultContext);

export const VulcanContext: React.FC<VulcanContextProps> = observer((props) => {
    const { translations, children, config } = props;

    return (
        <VulcanContextProvider.Provider value={{ translations, config } || defaultContext}>
            {children}
        </VulcanContextProvider.Provider>
    );
});
